import React from 'react'
import { Container, Navbar, Nav } from 'react-bootstrap'

// Import Libraries
import { LinkContainer } from 'react-router-bootstrap'

// Import Styles
import styles from './styles/Header.module.css'

const Header = () => {
  return (
    <header className={styles.header}>
      <Container>
        <Navbar expand='lg'>
          <LinkContainer to='/'>
            <Navbar.Brand style={{ fontWeight: 'bold' }}>
              <b>JOB PORTAL</b>
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ml-auto'>
              <Nav.Link href='#home'>Blog</Nav.Link>
              <LinkContainer to='/jobs'>
                <Nav.Link>Jobs</Nav.Link>
              </LinkContainer>
              <LinkContainer to='/hire-engineers'>
                <Nav.Link>Hire Engineers</Nav.Link>
              </LinkContainer>
              <LinkContainer to='/signin'>
                <Nav.Link>Login</Nav.Link>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  )
}

export default Header
